import type { ReactNode } from "react";
import { useInactividad, usePreferenciaMinutos } from "../../lib/inactividad";
import { Aviso } from "../ui/primitivos";
import { BloqueoPorInactividad } from "./BloqueoPorInactividad";

/**
 * Envuelve la app autenticada con el bloqueo por inactividad (ADR 0034).
 *
 * Es un componente aparte y no unas líneas en `App` por una razón de hooks: en
 * `App` los `return` tempranos —cargando, sin sesión— van antes de donde iría
 * este estado, y un hook detrás de un `return` condicional rompe las reglas de
 * hooks. Acá el componente solo se monta cuando ya hay sesión.
 *
 * Los hijos **se siguen renderizando** debajo del bloqueo: desmontarlos tiraría
 * lo que la persona estuviera escribiendo, y volver de un bloqueo a un
 * formulario vacío es peor que el bloqueo mismo.
 */
export function GuardiaDeInactividad({
  email,
  alSalir,
  children,
}: {
  email: string;
  alSalir: () => Promise<void>;
  children: ReactNode;
}) {
  const [minutos] = usePreferenciaMinutos();
  const { bloqueado, avisando, desbloquear } = useInactividad(minutos, true);

  return (
    <>
      {avisando && !bloqueado ? (
        <div className="-translate-x-1/2 fixed top-4 left-1/2 z-40 w-[min(28rem,calc(100vw-2rem))]">
          <Aviso>La pantalla se va a bloquear en unos minutos por inactividad.</Aviso>
        </div>
      ) : null}

      {children}

      {bloqueado ? (
        <BloqueoPorInactividad
          email={email}
          minutos={minutos}
          alDesbloquear={desbloquear}
          alSalir={alSalir}
        />
      ) : null}
    </>
  );
}
